import { useUserStore, AUTH_STEPS } from "@/stores/user";
import router, { routeIsRedirectable } from "@/router";

export const authGuard = (to, from, next) => {
  if (import.meta.env.VITE_COMPONENT_TESTING) return next();
  let query = to.query;

  if (!query.redirect && routeIsRedirectable(to)) {
    query.redirect = to.fullPath;
  }

  const user = useUserStore();
  if (!user.authenticated) {
    if (to.meta?.unauthenticatedOnly) return next();
    return next({ name: "SignIn", query });
  }

  const nextAuthStep = user.nextAuthStep();

  const expectedStep = to.meta.authStep || AUTH_STEPS.COMPLETED;
  if (nextAuthStep === expectedStep) {
    const redirect = query?.redirect;

    const authComplete = expectedStep === AUTH_STEPS.COMPLETED;

    if (authComplete && redirect) {
      const resolved = router.resolve(redirect);
      const noMatch = !resolved.matched.length;
      const isFallbackRoute =
        resolved.matched.length === 1 &&
        resolved.matched[0].name === "FallbackRoute";

      const isExternalRoute = noMatch || isFallbackRoute;
      if (isExternalRoute) return location.replace(redirect);

      const isRedirecting = to.fullPath !== resolved.fullPath;
      if (isRedirecting) return next(resolved);
    }

    if (authComplete && to.meta?.unauthenticatedOnly) {
      return next({ name: "Home" });
    }
    return next();
  }

  return next({ name: nextAuthStep, query });
};
